// ЕДИНАЯ ТОЧКА ХРАНЕНИЯ ТОКЕНА ИГРОКА.
//
// 🔴 ЗАЧЕМ ПОНАДОБИЛОСЬ (Telegram Mini App, 2026-08-13): раньше JWT жил ТОЛЬКО в cookie
// (`vue-cookies`), а она ставится с `SameSite=Lax` — в Telegram Web игра открывается в IFRAME, то есть
// в стороннем контексте, где браузер такую cookie не отдаёт вообще. Это не «может слететь», а
// гарантированно не работает: игрок логинился бы заново при каждом запуске мини-аппа.
//
// Решение: ПИШЕМ В ОБА хранилища (localStorage + cookie), ЧИТАЕМ сперва localStorage. Cookie
// оставлена намеренно — на неё опираются вкладки, открытые на прошлой сборке, и она же остаётся
// понятным местом для отладки в обычном браузере.
//
// 🔴 ПРАВИЛО: любое новое место, где читается или пишется токен, обязано идти ЧЕРЕЗ ЭТОТ МОДУЛЬ.
// Раньше токен трогали в четырёх файлах (`store/modules/auth.js`, `App.vue`, `main.js`,
// `store/modules/season.js` — последний подменяет активный токен на СЕЗОННЫЙ), и пропуск любого из
// них давал бы «вошёл в турнир, перезагрузил — играешь основным аккаунтом».

const JWT_KEY = 'cz_jwt';
const LEGACY_KEY = 'token'; // старый вход по внешнему токену (cookie `token`) — читаем для совместимости
const COOKIE_TTL_DAYS = 365;

function cookieGet(name) {
  const found = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return found ? decodeURIComponent(found[1]) : null;
}

function cookieSet(name, value) {
  const expires = new Date(Date.now() + COOKIE_TTL_DAYS * 86400e3).toUTCString();
  // SameSite=None требует Secure; на http-локалхосте такой cookie браузер не примет, поэтому там
  // остаёмся на Lax — в мини-аппе всё равно работает localStorage.
  const secure = window.location.protocol === 'https:';
  const suffix = secure ? '; SameSite=None; Secure' : '; SameSite=Lax';
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/${suffix}`;
}

function cookieRemove(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

function lsGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null; // приватный режим/запрет хранилища — молча падаем на cookie
  }
}

function lsSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) { /* см. lsGet */ }
}

function lsRemove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (e) { /* см. lsGet */ }
}

/** Текущий JWT игрока (или null). Порядок: localStorage → cookie. */
export function getJwt() {
  return lsGet(JWT_KEY) || cookieGet('jwt') || null;
}

/** Сохранить JWT в оба хранилища. Пустое значение = очистить. */
export function setJwt(jwt) {
  if (!jwt) return clearJwt();
  lsSet(JWT_KEY, jwt);
  cookieSet('jwt', jwt);
  return jwt;
}

/** Забыть токен (выход из аккаунта). */
export function clearJwt() {
  lsRemove(JWT_KEY);
  cookieRemove('jwt');
  return null;
}

/** Старый внешний токен (cookie `token`) — только чтение/очистка, новых мы его не заводим. */
export function getLegacyToken() {
  return lsGet(LEGACY_KEY) || cookieGet(LEGACY_KEY) || null;
}

export function setLegacyToken(value) {
  if (!value) return;
  lsSet(LEGACY_KEY, value);
  cookieSet(LEGACY_KEY, value);
}

export function clearLegacyToken() {
  lsRemove(LEGACY_KEY);
  cookieRemove(LEGACY_KEY);
}

/** Заголовок авторизации для axios — мержим, а НЕ затираем дефолты целиком. */
export function applyAuthHeader(axiosInstance, jwt) {
  if (!axiosInstance) return;
  const headers = { ...(axiosInstance.defaults.headers || {}) };
  if (jwt) headers.Authorization = `bearer ${jwt}`;
  else delete headers.Authorization;
  axiosInstance.defaults.headers = headers;
}
